import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { Job } from "@/types";

/**
 * This hook is used to update a job for a job query without refetching the entire query.
 */
export const useSetJob = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ job }: { job: Job }) => {
    queryClient.setQueryData(["job", currentCompanyId, job.id], job);
  };
};
